import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { LavaLand_Responsive } from "../LavaLand/game_responsive";


    export class LavaLandLink_Responsive extends LavaLand_Responsive {      
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "LavaLandLink");
       }

    }